import { GRNCreate } from './GRNCreate';
import { GRNEdit } from './GRNEdit';
import { GRNItemEdit } from './GRNItemEdit';
import { GRNList } from './GRNList';
import { GRNShow } from './GRNShow';

export const goods_receipts = {
    list: GRNList,
    create: GRNCreate,
    edit: GRNEdit,
    show: GRNShow,
};

export const grn_items = {
    edit: GRNItemEdit,
};
